import React from "react";
import { getGroupData, getUserDataByMail } from "../utils/utils";
import { LoopCircleLoading } from "react-loadingg";
import Matches from "./matching/Matches";
import { connect } from "react-redux";
import setMatches from "../actions/matchList";
import setUser from "../actions/currUser";
import Toolbar from "./Menu/Toolbar";
import SideDrawer from "./Menu/SideDrawer";
import BackDrop from "./Menu/BackDrop";
const fields = require("./matching/fields");
document.body.style = "background: #F6F7F9;";

class UserHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      allData: {},
      menuOpen: false,
    };
  }

  menuClickHandler = () => {
    this.setState((prevState) => {
      return { menuOpen: !prevState.menuOpen };
    });
  };

  backDropClickHandler = () => {
    this.setState({ menuOpen: false });
  };

  async componentDidMount() {
    let dataType;
    if (this.props.currUser.type === "student") {
      dataType = "parent";
    } else {
      dataType = "student";
    }
    let matches = this.props.match.matchList;
    if (matches.length === 0) {
      matches = await getGroupData(dataType);
      this.props.setData(matches);
    }
    this.setState({
      allData: matches,
      isLoading: false,
    });
  }

  render() {
    let sideDrawer;
    let backDrop;

    if (this.state.menuOpen) {
      sideDrawer = (
        <SideDrawer
          userData={this.props.currUser}
          closeMenu={this.backDropClickHandler}
        />
      );
      backDrop = <BackDrop click={this.backDropClickHandler} />;
    }

    return (
      <div style={{ height: "100%" }}>
        {this.state.isLoading ? (
          <LoopCircleLoading />
        ) : (
          <div>
            <Toolbar
              drawerClickHandler={this.menuClickHandler}
              textPage="תוצאות חיפוש"
            />
            {sideDrawer}
            {backDrop}
            <main style={{ marginTop: "50px" }}>
              {this.state.allData.length === 0 ? (
                "No matches"
              ) : (
                <Matches
                  user={this.props.currUser}
                  matchList={this.state.allData}
                  matchFields={fields.rank}
                  cityScore ={fields.cityScore}
                />
              )}
            </main>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    match: state.match,
    currUser: state.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setData: (data) => dispatch(setMatches(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserHome);
